import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
// import MoreVertIcon from '@material-ui/icons/MoreVert'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { expandLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { lineDeleteRequest } from '../../../../action/line-actions'
import { markerDeleteRequest } from '../../../../action/marker-actions'
import { polygonDeleteRequest } from '../../../../action/polygon-actions'
import { circleDeleteRequest } from '../../../../action/circle-actions'
import { photoDeleteRequest } from '../../../../action/photo-actions'
import { trackDeleteRequest } from '../../../../action/track-actions'
import { selectedObjectIdNull } from '../../../../action/map-object-id'
import { boundaryDeleteRequest } from '../../../../action/boundary-actions'
import ConfirmRemoval from '../common/confirm-removal'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../../action/infowindow-action'

const MyContentItem = props => {
  const { data, mapReference, active, setActive, expandLeftToolbar, selectedObjectIdNull } = props,
    { measureType, name } = data,
    [expanded, toggleExpand] = useState(false),
    [loadSpinner, setLoadSpinner] = useState(false),
    [confirmRemoval, setConfirmRemoval] = useState(false),
    cancelRemoval = () => {
      setConfirmRemoval(false)
      toggleExpand(false)
    },
    removeObject = () => {
      const deleteFunc = props[`${data.measureType}DeleteRequest`] || props.boundaryDeleteRequest
      setLoadSpinner(true)
      setTimeout(() => {
        setLoadSpinner(false)
      }, [1000 * 5])
      if (typeof data.mapObj == 'function') {
        data.mapObj().setMap(null)
      }
      cancelRemoval()
      props.setHideFunction(props.type)
      deleteFunc(data.id)
        .then((res) => {
          setLoadSpinner(false)
        })
        .catch((err) => {
          setLoadSpinner(false)
          console.log('error is at deleteFunc api', err)
        })
    },
    getIcon = () => {
      if (data.thumbnailUrl) {
        return data.thumbnailUrl
      }
      if (data.imageUrl) {
        return data.imageUrl
      }
      if (data.photo) {
        return data.photo.thumbnailUrl
      }
      if (measureType === 'marker') {
        const { markerTypeId } = data,
          url = props.markerTypes105.find(type => {
            return type.id === markerTypeId
          })
        return url ? url.iconUrl : ''
      }
      if (measureType === 'line') {
        return '../../../../../asset/Line_Dk_Green_Lg.png'
      }
      if (measureType === 'track') {
        return '../../../../../asset/Tracks_Dk_Green.png'
      }
      if (measureType === 'circle') {
        return '../../../../../asset/Circle_Dk_Green_Lg.png'
      }
      if (measureType === 'polygon') {
        return '../../../../../asset/Draw-Shape_Thin_589500_ldpi.png'
      }
    },
    goTo = () => {
      if (measureType === 'marker' || measureType === 'photo') {
        mapReference.setZoom(17)
        mapReference.setCenter(data.mapObj().position)
      }
      else if (measureType === 'track' || measureType === 'line' || measureType === 'polygon') {
        const path = data.mapObj ? data.mapObj().getPath() : null
        if (path) {
          const shapeBounds = new google.maps.LatLngBounds()
          path.forEach(pt => {
            try {
              shapeBounds.extend(pt)
            } catch (error) {
              console.warn('Could not extend shape bounds for user object: ', error)
            }
          })
          mapReference.fitBounds(shapeBounds, { left: 20, top: 20, right: 20, bottom: 20 })
        } else console.error('Could not extend shape bounds for user object: missing JSON objects')
      }
      else if (measureType === 'circle') {
        mapReference.fitBounds(data.mapObj().getBounds())
      }
      else if (data.mapBoundaryCamera) {
        const target = data.mapBoundaryCamera,
          latLng = new google.maps.LatLng({ lat: target.targetLatitude, lng: target.targetLongitude })
        mapReference.setCenter(latLng)
        mapReference.setZoom(target.zoom)
      } else {
        console.error('Missing JSON object', data)
      }
    },
    bgUrl = getIcon(),
    transform = expanded ? 'translateY(-20px)' : ''

  useEffect(() => {
    // props.infoWindow && props.infoWindow.infoWindowFunction && setPovali(props.infoWindow.infoWindowFunction)
  }, [props.infoWindow])

  const buildContent = (url, color, urlIcon) => {
    const hasSpaces = url.includes(' ');
    const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
    // let colorMarker = color[0] === '#' ? color : '#' + color;
    let colorMarker
    if (color && color[0] == '#') {
      if (color.length <= 7) {
        colorMarker = color[0] == '#' ? color : '#' + color
      } else {
        colorMarker = color[0] == '#' ? color.substring(color.length == 8 ? 2 : color.length == 7 ? 1 : 0) : '#' + color.substring(color.length == 8 ? 2 : color.length == 7 ? 1 : 0)
      }
    } else {
      if (color && color.length <= 6) {
        colorMarker = color[0] == '#' ? color : '#' + color
      } else if (!color) {
        colorMarker = '#9ecc3b'
      }
      else {
        colorMarker = color && color[0] == '#' ? color && '#' + color.substring(color.length == 8 ? 2 : color && color.length == 7 ? 1 : 0) : '#' + color && color.substring(color.length == 8 ? 2 : '#' + color.length == 7 ? 1 : 0)
      }
    }
    return (
      <div>
        <svg
          className="default-size-marker-content"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          {/* Define the clipping path for the circle */}
          <defs>
            <clipPath id="circleClip">
              <circle cx="8" cy="6" r="5" />
            </clipPath>
          </defs>
          <rect width="16" height="16" id="icon-bound" fill="none" />
          <path
            d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
            fill={colorMarker[0] == '#' ? colorMarker : '#' + colorMarker}
          />
          <circle className="" cx="8" cy="6" r="5" fill="#FFFFFF" />

          {/* Image inside the circle with clipping path */}
          <image
            xlinkHref={imageUrl ? imageUrl : urlIcon}
            x="5"
            y="3"
            width="6"
            height="6"
            clipPath="url(#circleClip)"
          />
        </svg>
      </div>
    );
  };

  let onContentItemCLick = (e) => {
    e.stopPropagation()
    selectedObjectIdNull()
    setActive(data.id, data, props.infoWindow)
    goTo()
  }

  return (
    <div className={`my-content-item ${active ? 'my-content-active' : ''}`}>
      {loadSpinner && <div class="loader-spinner-my-content"></div>}
      <div className='my-content-upper' onClick={onContentItemCLick}>
        {data.markerType ? buildContent(data.markerType.vectorIconUrl, data.color, data.markerType.iconUrl) : <div className='my-content-icon' style={{ backgroundImage: `url(${bgUrl})` }}></div>}
      </div>
      <div className='my-content-lower' style={{ transform }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p className='my-content-text'>{name}</p>
          <MoreVertIcon
            onClick={(e) => {
              e.stopPropagation()
              setLoadSpinner(false)
              toggleExpand(!expanded)
            }}
            style={{
              fontSize: '20px',
              textAlign: 'center'
            }} />
        </div>
        {
          expanded ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 20 }}>
              <div className='content-buttons-style edit-button-container'
                onClick={(e) => {
                  e.stopPropagation()
                  if (data.measureType === 'boundary' || data.mapObj || !data.measureType) {
                    if (!data.measureType)
                      data.measureType = 'boundary'
                    goTo()
                    expandLeftToolbar({ dialog: 'edit', editable: data })
                  } else console.error('Cannot edit content due to missing JSON objects')
                }}
                style={{}}><p className=' remove-button-class'>EDIT</p></div>
              <div className='content-buttons-style remove-button-container' onClick={(e) => {
                // props.setHideFunction(props.type)
                e.stopPropagation()
                if (data.measureType === 'boundary' || data.mapObj || !data.measureType) {
                  setConfirmRemoval(true)
                } else console.error('Cannot delete content due to missing JSON objects')
              }}
                style={{}}><p className='remove-button-class'>DELETE</p></div>
            </div>
          ) : null
        }
      </div>
      {
        confirmRemoval ? <ConfirmRemoval
          type={data.measureType}
          cancel={cancelRemoval.bind(this)}
          remove={removeObject.bind(this)}
        /> : null
      }
    </div >
  )
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  markerTypes105: state.markerTypes105,
  infoWindow: state.infoWindow
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: data => dispatch(expandLeftToolbar(data)),
  markerDeleteRequest: id => dispatch(markerDeleteRequest(id)),
  lineDeleteRequest: id => dispatch(lineDeleteRequest(id)),
  circleDeleteRequest: id => dispatch(circleDeleteRequest(id)),
  polygonDeleteRequest: id => dispatch(polygonDeleteRequest(id)),
  photoDeleteRequest: id => dispatch(photoDeleteRequest(id)),
  trackDeleteRequest: id => dispatch(trackDeleteRequest(id)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  infoWindowCloseAction: () => dispatch(infoWindowCloseAction()),
  boundaryDeleteRequest: (id) => dispatch(boundaryDeleteRequest(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(MyContentItem)